











































import { Vue, Component, Prop } from 'vue-property-decorator';
import { client } from '../../shared';
import { Verification } from '../../shared/dtos';

@Component({
  components: {},
})
export default class Verify extends Vue {
  /* ------------- Data -------------------- */
  public result: any = {
    message: '',
    error: false,
  };
  /* ------------- Props ------------------- */
  /* ------------- Computed ---------------- */
  /* ------------- Methods ----------------- */
  /* ------------- Lifecycle Hooks --------- */
  mounted() {
    this.processId(this.$route.params.id);
  }

  public async processId(id: string) {
    if (id) {
      await client.get(new Verification({ Id: id })).then(
        (result: any) => {
          this.result.message = result.Result;
        },
        (error: any) => {
          this.result.error = true;
          this.result.message = error.responseStatus.message;
        },
      );
    }
  }
}
